import { InjectionToken } from '@angular/core';

export interface UnleashConfiguration {
  url: string;
  clientKey: string;
  appName: string;
  environment: string;
}

export const UNLEASH_CONFIGURATION = new InjectionToken<UnleashConfiguration>('UNLEASH_CONFIGURATION');

export type FeatureFlagToggles =
  | ReleaseFeatureFlagToggles
  | OperationalFeatureFlagToggles
  | KillswitchFeatureFlagToggles;

export type ReleaseFeatureFlagToggles = 'news-bell' | 'document-pdf-viewer';

export type OperationalFeatureFlagToggles = 'use-test';

export type KillswitchFeatureFlagToggles = 'kill-test';

export type FeatureFlagToggleList = {
  [key in FeatureFlagToggles]?: boolean;
};
